module.exports = __webpack_public_path__ + "static/notebook-b8495b70451fe7f3fb8530f9d9afab1e.png";